import { Redirect, useLocation } from 'react-router-dom'

import { lang } from '../localization'
import Login from '../screens/Login'
import { LocalizedRoute } from './localizedRoutes'

export default function AuthRoutes() {
  const { pathname, search } = useLocation()

  if (!pathname.includes('/login')) {
    return <Redirect to={`/${lang}/login${search}`} />
  }

  return (
    <LocalizedRoute exact path="/login">
      <Login />
    </LocalizedRoute>
  )
}
